(function () {
  'use strict';

  var doc = document;
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var attr = function (el, name) { return el.getAttribute(name) || ''; };
  var values = function (row, key) { var v = attr(row, 'data-' + key); return v ? v.split('|').filter(Boolean) : []; };

  function initListFilter(root) {
    $$('[data-filter-list]', root).forEach(function (box) {
      var q = $('[data-filter-search]', box);
      var rows = $$('[data-row]', box);
      var count = $('[data-filter-count]', box);
      var sort = $('[data-filter-sort]', box);
      var list = $('[data-rows]', box);
      var empty = $('[data-filter-empty]', box);
      var actions = $('[data-filter-actions]', box);
      var clear = $('[data-filter-clear]', box);
      var filters = $('[data-filters]', box);
      var toggle = $('[data-filters-toggle]', box);
      var params = new URLSearchParams(location.search);
      var timer;

      /* ---- facet options from the rows ---- */
      var groups = $$('[data-facet]', box).filter(function (g) {
        var key = attr(g, 'data-facet');
        var labels = {};
        try { labels = JSON.parse(attr(g, 'data-labels') || '{}'); } catch (e) { /* no label map */ }
        var seen = {};
        rows.forEach(function (r) { values(r, key).forEach(function (v) { seen[v] = true; }); });
        var opts = Object.keys(seen).sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
        if (!opts.length) { g.remove(); return false; }
        var preset = params.getAll(key);
        $('[data-facet-options]', g).innerHTML = opts.map(function (v) {
          return '<li><label class="filter__check"><input type="checkbox" value="' + esc(v) + '"' +
            (preset.indexOf(v) > -1 ? ' checked' : '') + '> <span>' + esc(labels[v] || v) +
            '</span> <span class="filter__count" data-facet-count></span></label></li>';
        }).join('');
        g.hidden = false;
        $$('input', g).forEach(function (c) { c.addEventListener('change', apply); });
        return true;
      });

      /* A variant SKU pasted from an order ("31061-3", "P40001-100", "34047L-5") names the product's
         sheet by its base code: search the code the sheet is filed under as well. */
      var SKU_SUFFIX = /^(p?\d{5}l?)-[a-z0-9.]+$/i;
      function term() {
        var t = (q && q.value || '').trim().toLowerCase(), m = SKU_SUFFIX.exec(t);
        return m ? m[1] : t;
      }
      function checked(g) { return $$('input:checked', g).map(function (c) { return c.value; }); }
      function selections() {
        var sel = {};
        groups.forEach(function (g) { sel[attr(g, 'data-facet')] = checked(g); });
        return sel;
      }
      function matchesTerm(r, t) {
        if (!t) return true;
        var hay = attr(r, 'data-search').toLowerCase();
        if (hay.indexOf(t) > -1) return true;
        /* a lyophilized code ("34047l") whose sheet is filed under the liquid base code */
        var base = /^p?\d{5}l$/.test(t) ? t.slice(0, -1) : '';
        return !!base && hay.indexOf(base) > -1;
      }
      function matchesFacets(r, sel, skip) {
        return Object.keys(sel).every(function (key) {
          if (key === skip || !sel[key].length) return true;
          var have = values(r, key);
          return sel[key].some(function (v) { return have.indexOf(v) > -1; });
        });
      }
      /* relevance while searching: code prefix, then title prefix, then title, then anything (product names) */
      function score(r, t) {
        if (!t) return 0;
        var code = attr(r, 'data-code').toLowerCase(), title = attr(r, 'data-title').toLowerCase();
        if (code && code.indexOf(t) === 0) return 0;
        if (title.indexOf(t) === 0) return 1;
        if (title.indexOf(t) > -1) return 2;
        return 3;
      }
      function resort() {
        if (!list) return;
        var dir = sort ? sort.value : 'relevance', t = term();
        var idx = function (r) { return parseInt(attr(r, 'data-index'), 10) || 0; };
        var byTitle = function (a, b) { return attr(a, 'data-title').localeCompare(attr(b, 'data-title')); };
        rows.slice().sort(function (a, b) {
          if (dir === 'title-asc') return byTitle(a, b);
          if (dir === 'code-asc') {
            return (attr(a, 'data-code') || '\uffff').localeCompare(attr(b, 'data-code') || '\uffff', undefined, { numeric: true }) || byTitle(a, b);
          }
          if (dir === 'date-desc') return attr(b, 'data-date').localeCompare(attr(a, 'data-date')) || byTitle(a, b);
          return (score(a, t) - score(b, t)) || (idx(a) - idx(b));
        }).forEach(function (r) { list.appendChild(r); });
      }
      function apply() {
        var t = term(), sel = selections(), shown = 0;
        rows.forEach(function (r) {
          var ok = matchesTerm(r, t) && matchesFacets(r, sel);
          r.hidden = !ok;
          if (ok) shown++;
        });
        groups.forEach(function (g) {
          var key = attr(g, 'data-facet');
          var pool = rows.filter(function (r) { return matchesTerm(r, t) && matchesFacets(r, sel, key); });
          $$('input', g).forEach(function (c) {
            var n = pool.filter(function (r) { return values(r, key).indexOf(c.value) > -1; }).length;
            var label = c.parentNode;
            $('[data-facet-count]', label).textContent = '(' + n + ')';
            label.classList.toggle('is-disabled', !n && !c.checked);
          });
        });
        if (count) count.textContent = shown;
        if (empty) empty.hidden = shown > 0;
        var active = !!t || Object.keys(sel).some(function (key) { return sel[key].length > 0; });
        if (actions) actions.hidden = !active;
        if (filters && active && window.matchMedia('(max-width: 989px)').matches && !filters.classList.contains('is-open')) {
          /* a ?q= / ?family= deep link on a phone: show the filters that are narrowing the list */
          setOpen(true);
        }
        resort();
      }
      function setOpen(open) {
        filters.classList.toggle('is-open', open);
        if (toggle) toggle.setAttribute('aria-expanded', String(open));
      }

      if (q) {
        if (params.get('q')) q.value = params.get('q');
        q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(apply, 80); });
        q.addEventListener('search', apply);
      }
      if (sort) sort.addEventListener('change', resort);
      if (clear) {
        clear.addEventListener('click', function () {
          if (q) q.value = '';
          groups.forEach(function (g) { $$('input:checked', g).forEach(function (c) { c.checked = false; }); });
          apply();
          if (q) q.focus();
        });
      }
      if (toggle && filters) {
        toggle.addEventListener('click', function () { setOpen(!filters.classList.contains('is-open')); });
      }
      apply();
    });
  }

  window.theme.register(function (root) {
    initListFilter(root);
  });
})();
